import { RvType } from '../listings/mock-listings.data';

/** MD-source shorthand for rig-specific items. Matches the tags at the
 *  end of items in `docs/curbnturf-rv-checklists.md`. */
export type ChecklistRigTag = 'MH' | 'TT' | 'FW' | 'Toad';

export interface IChecklistItem {
  id: string;
  text: string;
  tags: ChecklistRigTag[];
}

export interface IChecklistSection {
  id: string;
  number: number;
  title: string;
  intro?: string;
  items: IChecklistItem[];
}

/** Maps the MD tag shorthand to concrete `RvType` values. Motorhomes cover
 *  all three Class variants. Untagged items apply to everyone. */
export const RIG_TAG_TO_TYPES: Record<ChecklistRigTag, RvType[]> = {
  MH: ['classA', 'classB', 'classC'],
  TT: ['travelTrailer'],
  FW: ['fifthWheel'],
  Toad: [],
};

/** Human-readable label for each rig tag — shown in the rig-picker chip. */
export const RIG_TAG_LABEL: Record<ChecklistRigTag, string> = {
  MH: 'Motorhome',
  TT: 'Travel Trailer',
  FW: 'Fifth Wheel',
  Toad: 'Towed Vehicle',
};

/** Inverse of RIG_TAG_TO_TYPES — used to auto-select the rig-picker chip
 *  based on the user's saved `IMyRv.type`. */
export function rvTypeToTag(type: string | null | undefined): ChecklistRigTag | null {
  if (!type) return null;
  if (type === 'travelTrailer') return 'TT';
  if (type === 'fifthWheel') return 'FW';
  if (type === 'classA' || type === 'classB' || type === 'classC') return 'MH';
  return null;
}
